import { Component, inject } from '@angular/core';
import { ModalComponent } from 'src/app/shared/components/modals/modal/modal.component';
import { LoaderButtonComponent } from 'src/app/shared/components/loader-button/loader-button/loader-button.component';
import { TextBoxComponent } from '@progress/kendo-angular-inputs';
import { TranslatePipe } from 'src/app/shared/pipes/translate/translate.pipe';
import { AlertComponent } from 'src/app/shared/components/ui/alert/alert.component';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';

@Component({
  selector: 'bizz-certificates-found-warning',
  standalone: true,
  imports: [
    ModalComponent,
    LoaderButtonComponent,
    TextBoxComponent,
    TranslatePipe,
    AlertComponent
  ],
  templateUrl: './certificates-found-warning.component.html',
  styleUrl: './certificates-found-warning.component.scss'
})
export class CertificatesFoundWarningComponent {

  public readonly dialogRef = inject(DialogRef);
  public readonly dialogData:{count: number} = inject(DIALOG_DATA);

  public replace(translation: string): string {
    return translation.replace('{{count}}', this.dialogData.count.toString());
  }
}
